import React from 'react';
import { useTranslation } from 'react-i18next';
import ControlsActions from '../../../../common/controls/ControlsActions/ControlsActions';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { useGetUsefulLinksQuery } from '../../../../../redux/services/useful_links.jsx';
import { Spinner } from '../../../../common';

const UsefulLinksHP = ({ isEnglish }) => {
  const { t } = useTranslation();
  const { data: links, isLoading } = useGetUsefulLinksQuery(isEnglish);

  const renderLinks = () => {
    let title,
      url = null;
    return (
      <>
        <ControlsActions
          style={{
            marginTop: '-20px',
          }}
          actions={[
            {
              to: `${routes.cmsUsefulLinks}`,
              permission: 'useful-links.update',
            },
          ]}
        />
        <div className="useful-links-hp-container">
          {links.map((link) => {
            if (isEnglish) {
              title = link.title_en !== '' ? link.title_en : null;
              url = link.url_en !== '' ? link.url_en : link.url;
            } else {
              title = link.title;
              url = link.url;
            }
            if (link.visible && title !== null) {
              if (link.new) {
                return (
                  <div key={link.id}>
                    <a href={url}>
                      {title}
                      <sup>{t('Nové')}</sup>
                    </a>
                  </div>
                );
              } else {
                return (
                  <div key={link.id}>
                    <a href={url}>{title}</a>
                  </div>
                );
              }
            }
          })}
        </div>
      </>
    );
  };

  return isLoading ? (
    <Spinner />
  ) : (
    <div className="block-component-wrapper">{renderLinks()}</div>
  );
};

export default UsefulLinksHP;
